<template>
  <SoSkeleton v-if="current.recentImbpChange.isLoading" type="card" />
  <template v-else>
    <SoAlert
      v-if="current.recentImbpChange.isSuccess"
      type="info"
      data-testid="success-alert"
    >
      <strong>Tell the customer:</strong> We're adding new slots every week and
      have added you to our waiting list to get an appointment at a time that
      works for you. We will be in contact with you when there are new
      appointment slots available.
    </SoAlert>
    <SoAlert
      v-if="current.recentImbpChange.isError"
      type="error"
      data-testid="error-alert"
    >
      <p>
        We were unable to save the customer's preferred appointment dates due to
        a technical issue.
      </p>
      <p>
        <strong>Tell the customer:</strong> We're adding new appointment slots
        every week. Please check back later to find an appointment time that
        works for you.
      </p>
    </SoAlert>
  </template>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoAlert from "@/components/SoAlert.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoSkeleton,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
  })
</script>
